/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PublicMonitorV2ProviderDto = {
    /**
     * Display name of the user, API token, or source
     */
    name?: string;
    /**
     * Provider type
     */
    type?: PublicMonitorV2ProviderDto.type;
};

export namespace PublicMonitorV2ProviderDto {

    /**
     * Provider type
     */
    export enum type {
        USER = 'USER',
        ACCESS_TOKEN = 'ACCESS_TOKEN',
        SOURCE = 'SOURCE',
        GENERIC = 'GENERIC',
    }


}
